<template>
  <scout-form
    label="除外する会員を指定"
    has-child
  >
    <scout-form
      :is-modified="isModifiedThisJob"
      label="この自社求人でスカウトした時期を指定して除外"
      data-test="scout-this-job"
    >
      <term-select
        :selected-option="scoutThisJobOption"
        :from="scoutThisJobFrom"
        :to="scoutThisJobTo"
        :without-today="true"
        date-label="スカウト送信日"
        notice="※現在の掲載期間中にスカウトした会員は、スカウト済み一覧から再送できるため、すでに除外されています。現在の掲載期間よりも前にスカウトしたことがある会員を除外したい場合に、こちらを指定してください。"
        @update:selectedOption="$emit('update:scoutThisJobOption', $event)"
        @update:from="$emit('update:scoutThisJobFrom', $event)"
        @update:to="$emit('update:scoutThisJobTo', $event)"
      />
    </scout-form>
    <scout-form
      :is-modified="isModifiedOtherJob"
      label="その他の自社求人でスカウトした時期を指定して除外"
      data-test="scout-other-job"
    >
      <term-select
        :selected-option="scoutOtherJobOption"
        :from="scoutOtherJobFrom"
        :to="scoutOtherJobTo"
        :without-today="true"
        date-label="スカウト送信日"
        @update:selectedOption="$emit('update:scoutOtherJobOption', $event)"
        @update:from="$emit('update:scoutOtherJobFrom', $event)"
        @update:to="$emit('update:scoutOtherJobTo', $event)"
      />
    </scout-form>
    <scout-form-candidate-other-job
      :has-candidate-other-job="hasCandidateOtherJob"
      @update:hasCandidateOtherJob="$emit('update:has-candidate-other-job', $event)"
    />
    <scout-form-other-excludes
      :applies-other-company="appliesOtherCompany"
      @update:appliesOtherCompany="$emit('update:applies-other-company', $event)"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import TermSelect from '@/components/atoms/TermSelect'
import ScoutFormOtherExcludes from '@/components/atoms/ScoutFormOtherExcludes'
import ScoutFormCandidateOtherJob from '@/components/atoms/ScoutFormCandidateOtherJob'

export default {
  components: {
    ScoutForm,
    TermSelect,
    ScoutFormOtherExcludes,
    ScoutFormCandidateOtherJob
  },
  props: {
    scoutThisJobOption: {
      default: () => { return { terms: 'select' } },
      type: Object
    },
    scoutThisJobFrom: {
      required: true,
      type: String
    },
    scoutThisJobTo: {
      required: true,
      type: String
    },
    scoutOtherJobOption: {
      default: () => { return { terms: 'select' } },
      type: Object
    },
    scoutOtherJobFrom: {
      required: true,
      type: String
    },
    scoutOtherJobTo: {
      required: true,
      type: String
    },
    appliesOtherCompany: {
      required: true,
      type: Boolean
    },
    hasCandidateOtherJob: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    isModifiedThisJob () {
      return !!this.scoutThisJobFrom && !!this.scoutThisJobTo
    },
    isModifiedOtherJob () {
      return !!this.scoutOtherJobFrom && !!this.scoutOtherJobTo
    }
  }
}
</script>
